import { ComponentType, FC } from 'react'
import { useSelector } from 'react-redux'
import { settingsSelectors } from 'store/settings'
import { Navigate, useLocation } from 'react-router'

export const withAuth = <P extends object>(WrappedComponent: ComponentType<P>): FC<P> => {
  // Create the wrapped component
  const WithAuthComponent: FC<P> = (props) => {
    const isLogged = useSelector(settingsSelectors.isLogged)
    const location = useLocation()

    console.debug({ location })

    if (!isLogged) {
      return <Navigate to="/login" state={{ from: location }} replace />
    }

    // Pass the original props along with the injected auth props
    return <WrappedComponent {...props} />
  }

  // Set display name for debugging
  WithAuthComponent.displayName = `WithAuth(${getDisplayName(WrappedComponent)})`

  // Cast the result to the correct type
  return WithAuthComponent
}

/**
 * Helper function to get the display name of a component
 * @param WrappedComponent - The component to get the name from
 * @returns The display name of the component
 */
function getDisplayName(WrappedComponent: ComponentType<any>): string {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}
